module.exports = __webpack_public_path__ + "static/media/octaflyte_logo.0cb96e9e.webp";